import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import type { MainSearchSuggestionsScope } from "@/shop/api/mainSearch";

import * as MainSearchActions from "../actions";
import type { IMainSearchSuggestionsResultState } from "../types";

type MainSearchSuggestionsActionType =
  | ActionType<typeof MainSearchActions.fetchSuggestionsStart>
  | ActionType<typeof MainSearchActions.fetchSuggestionsSuccess>
  | ActionType<typeof MainSearchActions.fetchSuggestionsFail>
  | ActionType<typeof MainSearchActions.clearSuggestionsResults>;

export function createMainSearchSuggestionInitialState(source: MainSearchSuggestionsScope): IMainSearchSuggestionsResultState {
  return {
    source,
    data: null!,
    isFetching: false,
    hasError: false
  };
}

export function createMainSearchSuggestionResultReducer(initialState: IMainSearchSuggestionsResultState) {
  return function mainSearchResultReducer(
    state: IMainSearchSuggestionsResultState = initialState,
    action: MainSearchSuggestionsActionType
  ): IMainSearchSuggestionsResultState {
    if (action.meta && action.meta.collection === state.source) {
      switch (action.type) {
        case getType(MainSearchActions.fetchSuggestionsStart):
          return { ...state, isFetching: true };
        case getType(MainSearchActions.fetchSuggestionsFail):
          return { ...state, isFetching: false, hasError: true };
        case getType(MainSearchActions.fetchSuggestionsSuccess):
          return { ...state, isFetching: false, data: action.payload };
        case getType(MainSearchActions.clearSuggestionsResults):
          return { ...createMainSearchSuggestionInitialState(action.meta.collection) };
        default:
          return state;
      }
    } else {
      return state;
    }
  };
}
